/* global AppSettings, google */
/**
 * CoordinatorModule adds coordinates to a form just before submission
 * provided that a latitude and longitude field are available
 *
 * @author Vincent Bruijn <vincent-bruijn@g-star.com>
 */
import $ from 'jquery';

let hasGeocoded = false;

function Coordinator() {}

Coordinator.prototype.initialize = function initialize(form) {
  hasGeocoded = false;
  this.form = form;

  const googleApiJs = `//maps.google.com/maps/api/js?key=${AppSettings.googleMapsKey}&language=${AppSettings.language}&libraries=geometry,places`;

  window.GSRD.loadAsset(googleApiJs).then(this.bindEvents.bind(this));
};

Coordinator.prototype.bindEvents = function bindEvents() {
  this.form.jq.data('api').attachSubmitCallback(this.geocodeAddress.bind(this), 100);
};

Coordinator.prototype.geocodeAddress = function geocodeAddress() {
  const deferred = $.Deferred();

  if (hasGeocoded) {
    return deferred.resolve();
  }

  const addressSelector = '[name="postcode"], [name="houseNumber"], [name="street"], [name="city"]';
  const formattedAddress = this.form.jq
    .find(addressSelector)
    .toArray()
    .map(function (el) {
      return el.value;
    })
    .join(' ');

  const Geocoder = new google.maps.Geocoder();
  const geoData = {
    address: formattedAddress,
    region: AppSettings.country.toLowerCase() === 'gb' ? 'uk' : AppSettings.country.toLowerCase(),
    componentRestrictions: {
      country: AppSettings.country.toUpperCase(),
    },
  };

  Geocoder.geocode(
    geoData,
    function (response, status) {
      if (status === 'OK' && response.length) {
        this.form.querySelector('[name="latitude"]').value = response[0].geometry.location.lat();
        this.form.querySelector('[name="longitude"]').value = response[0].geometry.location.lng();
      }
      hasGeocoded = true;

      deferred.resolve();
    }.bind(this)
  );

  return deferred.promise();
};

export default new Coordinator();
